var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"border flex flex-col border-neutral-50 bg-white p-5 lg:p-8"},[(_vm.$slots.title)?_c('h3',{staticClass:"mb-2 text-lg font-medium text-neutral-900"},[_vm._t("title")],2):_vm._e(),(_vm.$slots.buttonContent)?_c('div',{staticClass:"mt-2 grid gap-2",class:{
      'md:grid-cols-2': _vm.$allowed([
        'borettisAdmin',
        'masterFranchise',
        'franchisee' ]),
    }},[_vm._t("buttonContent")],2):_vm._e(),(_vm.$slots.content)?_c('div',{staticClass:"flex-grow mb-8 text-sm text-neutral-400"},[_vm._t("content")],2):_vm._e(),(_vm.$slots.bottom)?_c('div',{staticClass:"grid gap-2"},[_vm._t("bottom")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }